import 'lazysizes';

import Alpine from 'alpinejs';

import checkFaders from './components/animations.js';
import header from './components/header.js';
import projects from './components/projects.js';
import gallery from './components/gallery.js';
import form from './components/form.js';

Alpine.data('header', header);
Alpine.data('gallery', gallery);
Alpine.data('projects', projects);
Alpine.data('form', form);

window.addEventListener('load', () => {
  window.addEventListener('scroll', checkFaders);
  
  checkFaders();
  
  Alpine.start();

  document.querySelectorAll('[href*="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      const selector = link.getAttribute('href');
      const offset = document.querySelector(selector).offsetTop - 100;
      window.scrollTo({
        top: offset,
        behavior: 'smooth'
      });
    });
  });
});
